import { render, staticRenderFns } from "./headTop.vue?vue&type=template&id=56842a85"
import script from "./headTop.vue?vue&type=script&lang=js"
export * from "./headTop.vue?vue&type=script&lang=js"
import style0 from "./headTop.vue?vue&type=style&index=0&id=56842a85&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports